'use client';

import {useSession} from 'next-auth/react';
import {useEffect} from 'react';

import Loading from './(auth)/loading';
import {BaseErrorPage} from './_components/BaseErrorPage';
import {useDatadog} from './_hooks/useDatadog';

const GlobalError = ({error, reset}: {error: Error & {digest?: string}; reset: () => void}) => {
  const session = useSession();
  const {captureException} = useDatadog();

  useEffect(() => {
    captureException(error, {
      digest: error.digest,
    });
  }, [error, captureException]);

  const isSessionLoading = session?.status === `loading`;

  return (
    <html>
      <body>
        {isSessionLoading ? (
          <Loading />
        ) : (
          <BaseErrorPage
            handleReset={reset}
            heading={{
              text: error.name ?? `Something went wrong`,
              show: true,
            }}
            button={{
              text: `Try again`,
            }}
          />
        )}
      </body>
    </html>
  );
};

export default GlobalError;
